import { contractRequest } from "../contract-request";
import type { RegionalSession } from "../regional-request";
import { sitePreviewClient } from "../rpc/site-preview";

/**
 * What a website looks like — its icon and its name — read by the regional API, so the browser
 * never loads the site itself. The server may take a few seconds on a slow site, so the session
 * should carry a longer bound than the default (`connectionsOptions`).
 */
export const fetchSitePreview = ({ scope, options }: RegionalSession, url: string) =>
  contractRequest(sitePreviewClient, scope, options, (client, workspaceId, call) =>
    client.preview({ params: { workspaceId }, query: { url } }, call),
  );
